import {
    Component,
    OnInit,
    OnDestroy,
    QueryList,
    ViewChildren,
    ElementRef,
    ViewChild,
    AfterViewInit
} from '@angular/core';
import { UploadEvent, FileSystemFileEntry, UploadFile } from 'ngx-file-drop';
import { AppConfirmDialogComponent } from '@core/components/confirm-dialog/confirm-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AppConfigService } from '@core/services/config.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalService } from '../local.services';
import { takeUntil, startWith, map } from 'rxjs/operators';
import { Local, Attachment, Bank } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { ToastrService } from 'ngx-toastr';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { AppPopOverStepsComponent } from '../popover/popover.component';
import { AppUtils } from '@core/appUtils';
import { AppValidate } from '../validate';
import { VARIABLES } from 'environments/config';
export interface Files {
    name: string;
    path: string;
    size: number;
    type: string;
}

@Component({
    selector: 'app-local-step-9',
    templateUrl: './step9.component.html',
    styleUrls: ['./step9.component.scss']
})
export class AppStep9Component implements OnInit, AfterViewInit, OnDestroy {
    optionSelected = 'Save';
    @ViewChild('fvoucher') fvoucher: ElementRef;
    alertDialogRef: MatDialogRef<AppAlertDialogComponent>;
    local_id: any;
    regForm: FormGroup;
    regFormErrors: any;
    local: Local;
    bank: Bank[] = [];
    private _unsubscribeAll: Subject<any>;
    confirmDialogRef: MatDialogRef<AppConfirmDialogComponent>;
    public files: UploadFile[] = [];
    filesVoucher: Attachment[] = [];
    filteredOptions: Observable<Bank[]>;
    @ViewChildren(AppPopOverStepsComponent) popovers: QueryList<
        AppPopOverStepsComponent
    >;
    loading = false;
    constructor(
        private appConfig: AppConfigService,
        private activatedRoute: ActivatedRoute,
        private _toastr: ToastrService,
        private _formBuilder: FormBuilder,
        private _scrollService: ScrollService,
        private _router: Router,
        private _localService: LocalService,
        public dialog: MatDialog
    ) {
        this.appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.regFormErrors = {
            bank_id: {},
            bank_account: {}
        };
        this.local = new Local();
        this._unsubscribeAll = new Subject();
    }
    handleChangeSelected(opt) {
        this.optionSelected = opt;
    }
    validateLengthControl(value): boolean {
        const _value: string = value;
        if (_value === null) {
            return false;
        }
        return _value.length > 0 ? true : false;
    }
    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.activatedRoute.params.subscribe(routeParams => {
                this.local_id = routeParams.id;
            });
        });

        this.regForm = this._formBuilder.group({
            bank_id: [null, [AppUtils.validateObjectBank.bind(this)]],
            bank_account: ['']
        });
        this.regForm.valueChanges.subscribe(() => {
            this.onRegisterFormValuesChanged();
        });

        this._localService.localOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                console.log('local', local);
                this.local = new Local(local);
                this.regForm.get('bank_id').setValue(this.local.bank);
                this.regForm
                    .get('bank_account')
                    .setValue(this.local.bank_account);

                const filesVoucher = this.local.attachments.filter(
                    item => item.type === 'voucher'
                );
                if (filesVoucher.length > 0) {
                    this.filesVoucher = filesVoucher;
                }
            });

        this._localService.bankOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(bank => {
                this.bank = bank;
            });

        this.filteredOptions = this.regForm.get('bank_id').valueChanges.pipe(
            startWith<string | Bank>(''),
            map(value =>
                typeof value === 'string' ? value : value ? value.name : ''
            ),
            map(name => (name ? this._filter(name) : this.bank.slice()))
        );

        this.handleChanges();
    }
    ngAfterViewInit() {
        this._scrollService._init();
    }

    displayFn(bank?: Bank): string | undefined {
        return bank ? bank.name : undefined;
    }

    handleChanges() {
        AppValidate.Number(<FormControl>this.regForm.get('bank_account'));
    }

    private _filter(name: string): Bank[] {
        const filterValue = name.toLowerCase();
        return this.bank.filter(
            bank => bank.name.toLowerCase().indexOf(filterValue) === 0
        );
    }

    public dropped(event: UploadEvent) {
        if (this.filesVoucher.length === 0 && event.files.length > 3) {
            this.alert('Solo puedes subir 3 fotos');
        } else {
            const countFiles = this.filesVoucher.length + event.files.length;
            if (countFiles > 3) {
                this.alert('Solo puedes subir 3 fotos');
            } else {
                const _formData: FormData = new FormData();
                _formData.set('type', 'voucher');
                for (const droppedFile of event.files) {
                    if (droppedFile.fileEntry.isFile) {
                        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                        fileEntry.file(async (file: File) => {
                            this.uploadFiles(_formData, file);
                        });
                    }
                }
            }
        }
    }

    onFileChanged(event) {
        if (this.filesVoucher.length === 0 && event.target.files.length > 3) {
            this.alert('Solo puedes subir 3 fotos');
        } else {
            const countFiles =
                this.filesVoucher.length + event.target.files.length;
            if (countFiles > 3) {
                this.alert('Solo puedes subir 3 fotos');
            } else {
                const selectedFiles: FileList[] = event.target.files;
                const _formData: FormData = new FormData();
                _formData.set('type', 'voucher');
                Array.from(selectedFiles).forEach(async (file: any) => {
                    this.uploadFiles(_formData, file);
                });
            }
        }
    }
    async uploadFiles(_formData, file: any) {
        const ext = this.getExtension(file.name);
        if (
            ext === 'pdf' ||
            ext === 'doc' ||
            ext === 'docx' ||
            ext === 'png' ||
            ext === 'jpg' ||
            ext === 'jpeg' ||
            ext === 'PNG' ||
            ext === 'JPG' ||
            ext === 'JPEG'
        ) {
            const size = file.size / 1024 / 1024;
            if (size > 5) {
                this._toastr.error(VARIABLES.MESSAGES.PHOTOS);
            } else {
                _formData.append('file', file, file.name);
                await this._localService
                    .addAttach(_formData)
                    .then((res: any) => {
                        this.filesVoucher.push(res.data);
                        this.fvoucher.nativeElement.value = '';
                    })
                    .catch((err: any) => {
                        this.fvoucher.nativeElement.value = '';
                        this._toastr.show('Error al subir archivo', 'Error');
                    });
            }
        } else {
            await this._toastr.error('Imagen no permitida');
            return;
        }
    }

    public fileOver(event) {}

    public fileLeave(event) {}

    onSubmit() {
        const data = this.regForm.getRawValue();
        const bank = this.regForm.get('bank_id').value;
        if (bank) {
            data.bank_id = bank.id;
        }

        if (this.optionSelected === 'Save') {
            if (!this.loading) {
                this.loading = true;
                this._localService
                    .update(data)
                    .then((res: any) => {
                        this.loading = false;
                        this.confirmDialogRef = this.dialog.open(
                            AppConfirmDialogComponent,
                            {
                                disableClose: true
                            }
                        );
                        this.confirmDialogRef.componentInstance.confirmMessage =
                            'Sus cambios han sido guardados correctamente';
                        this.confirmDialogRef.componentInstance.textSubtitle =
                            'No olvide seleccionar Finalizar para enviar su solicitud';
                        this.confirmDialogRef.componentInstance.messageButton =
                            'Aceptar';
                        this.confirmDialogRef.componentInstance.hideButtonCancel = false;
                        (window as any).gtag('event', 'conversion', {'send_to': 'AW-466382035/RX8hCKrFydQCENPZsd4B'});
                    })
                    .catch((err: any) => {
                        this.loading = false;
                    });
            }
        } else {
            this.confirmDialogRef = this.dialog.open(
                AppConfirmDialogComponent,
                {
                    disableClose: true
                }
            );

            this.confirmDialogRef.componentInstance.confirmMessage =
                '¿Estás seguro que quieres finalizar el proceso?';

            this.confirmDialogRef.afterClosed().subscribe(result => {
                if (!result) {
                    return;
                }
                if (!this.loading) {
                    this.loading = true;

                    this._localService
                        .finish(data)
                        .then((res: any) => {
                            this.loading = false;
                            this._router.navigate(['/local/registro/gracias']);
                            (window as any).gtag('event', 'conversion', {'send_to': 'AW-466382035/RX8hCKrFydQCENPZsd4B'});
                        })
                        .catch((err: any) => {
                            this.loading = false;
                        });
                }
                this.alertDialogRef = null;
            });
        }
    }

    onRegisterFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }
            this.regFormErrors[field] = {};
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    prev() {
        this._router.navigate([`/local/registro/8/${this.local_id}`]);
    }
    removeEstension(value: string) {
        return AppUtils.removeEstension(value);
    }
    remove(item) {
        if (item.hasOwnProperty('id')) {
            this._localService
                .deleteAttach(item.id)
                .then((res: any) => {
                    const index = this.filesVoucher.indexOf(item);
                    if (index !== -1) {
                        this.filesVoucher.splice(
                            this.filesVoucher.indexOf(item),
                            1
                        );
                    }
                })
                .catch((err: any) => {
                    if (err.ok === false && err.status === 400) {
                        alert('Error al eliminar');
                    }
                });
        } else {
            alert('Esta archivo no tiene ID');
        }
    }

    alert(msg) {
        this.alertDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.alertDialogRef.componentInstance.alertMessage = msg;
        this.alertDialogRef.afterClosed().subscribe(result => {
            this.alertDialogRef = null;
        });
    }

    toggle(index): void {
        this.popovers.forEach((pop: AppPopOverStepsComponent) => {
            if (pop.index === index) {
                pop.open = !!pop.open;
            } else {
                pop.open = false;
            }
        });
    }

    getExtension(filename: any) {
        const ext = filename.split('.').pop();
        return ext === filename ? '' : ext;
    }

    /*  ubigeo_id */
    get bank_id() {
        return this.regForm.get('bank_id');
    }
    get bank_id_value(): boolean {
        const _value = this.bank_id.value;
        if (_value === '') {
            return false;
        }
        return typeof _value === 'function' || typeof _value === 'object';
    }

    /*  bank_account */
    get bank_account() {
        return this.regForm.get('bank_account');
    }
    get bank_account_value(): boolean {
        const _value = this.bank_account.value;
        return _value ? true : false;
    }

    getDisabled() {
        if (this.regForm.valid && this.filesVoucher.length > 0) {
            return true;
        }
        return false;
    }
}
